import { render } from "./new-tag.vue?vue&type=template&id=4f3e5c30&lang=pug"
import script from "./new-tag.vue?vue&type=script&lang=js"
export * from "./new-tag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__